// src/components/modals/CitySelectorModal.js
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import useUserLocationStore from '../../contexts/useUserLocationStore';

const DEBUG = true; // Set to true to enable debug logs

const CitySelectorModal = ({ isOpen, onClose }) => {
  const [cities, setCities] = useState([]);
  const { userSelectedCity, setUserSelectedCity } = useUserLocationStore();

  useEffect(() => {
    fetch('/local_data/baseLocations.json')
      .then((res) => res.json())
      .then((data) => {
        setCities(data);
        if (DEBUG) console.log("Fetched cities:", data);
      })
      .catch((error) => {
        if (DEBUG) console.error("Error fetching cities:", error);
      });
  }, []);

  const handleCityClick = (city) => {
    if (DEBUG) console.log("City selected:", city);
    setUserSelectedCity(city); // Pass the entire city object with name and coords
    onClose(); // Optionally close the modal after selection
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-1000">
      <div className="relative bg-white p-6 rounded-lg w-full max-w-md max-h-screen overflow-y-auto">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <i className="bi bi-x-circle text-xl"></i>
        </button>

        <h2 className="text-xl font-bold mb-4">Select City</h2>
        
        <div className="grid grid-cols-3 gap-4">
          {cities.map((city) => (
            <button
              key={city.name}
              onClick={() => handleCityClick(city)} // Use handleCityClick to handle button clicks
              className={`w-full p-4 rounded text-center ${
                userSelectedCity?.name === city.name ? 'bg-[var(--brandprimary)] text-white border-2 border-blue-500' : 'bg-gray-300 text-gray-700'
              }`}
            >
              {city.name}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body // Render the modal directly into the body
  );
};

export default CitySelectorModal;
